import {
  ADD_UNASSIGNED_DATA,
  UPDATE_FETCH_UNASSIGNED_DATA_INPROGRESS,
  ADD_ASSIGNED_DATA,
  ADD_QC_CASES_DATA,
  ADD_LM_COMPLETE_DATA,
  UPDATE_FETCH_ASSIGNED_DATA_INPROGRESS,
  UPDATE_FETCH_LM_COMPLETE_DATA_INPROGRESS,
  UPDATE_FETCH_QC_DATA_INPROGRESS,
  ADD_LAB_TRANSFER_LIST,
  UNASSIGN_CASE_SUCCESS,
  UNASSIGN_CASE_ERROR,
  EMPTY_TRANSFER_LIST,
  ADD_TRANSFER_LIST,
  TRANSFER_CASE_SUCCESS,
  TRANSFER_CASE_ERROR,
  CORRECTION_CASE_SUCCESS,
  CORRECTION_CASE_ERROR,
  AMEND_CASE_INPROGRESS,
  AMEND_CASE_SUCCESS,
  AMEND_CASE_ERROR,
} from '../../actions'

export const getUnassignedDataReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_UNASSIGNED_DATA:
      return { ...state, ...action.payload }

    case UPDATE_FETCH_UNASSIGNED_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

export const getAssignedDataReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_ASSIGNED_DATA:
      return { ...state, ...action.payload }
    case UPDATE_FETCH_ASSIGNED_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

export const getQCCasesDataReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_QC_CASES_DATA:
      return { ...state, ...action.payload }
    case UPDATE_FETCH_QC_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

export const getLabManagerCompleteDataReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_LM_COMPLETE_DATA:
      return { ...state, ...action.payload }
    case UPDATE_FETCH_LM_COMPLETE_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

export const getLabTransferListReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_LAB_TRANSFER_LIST:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

const transferCase = {
  re_transfer_success: false,
  re_transfer_error: false,
}

export const transferResponseReducer = (state = transferCase, action) => {
  switch (action.type) {
    case TRANSFER_CASE_SUCCESS:
      return { ...state, re_transfer_success: true, re_transfer_error: false }
    case TRANSFER_CASE_ERROR:
      return { ...state, re_transfer_success: false, re_transfer_error: true }

    default:
      return state
  }
}

const correctionCase = {
  re_correction_success: false,
  re_correction_error: false,
}

export const correctionResponseReducer = (state = correctionCase, action) => {
  switch (action.type) {
    case CORRECTION_CASE_SUCCESS:
      return { ...state, re_correction_success: true, re_correction_error: false }
    case CORRECTION_CASE_ERROR:
      return { ...state, re_correction_success: false, re_correction_error: true }

    default:
      return state
  }
}

const amendCase = {
  re_amend_success: false,
  re_amend_error: false,
}

export const amendResponseReducer = (state = amendCase, action) => {
  switch (action.type) {
    case AMEND_CASE_SUCCESS:
      return { ...state, re_amend_success: true, re_amend_error: false }
    case AMEND_CASE_ERROR:
      return { ...state, re_amend_success: false, re_amend_error: true }
    case AMEND_CASE_INPROGRESS:
      return { ...state, re_amend_success: false, re_amend_error: false }
    default:
      return state
  }
}

const unassignCase = {
  re_unassignCase_success: false,
  re_unassignCase_error: false,
}

export const unassignResponseReducer = (state = unassignCase, action) => {
  switch (action.type) {
    case UNASSIGN_CASE_SUCCESS:
      return { ...state, re_unassignCase_success: true, re_unassignCase_error: false }
    case UNASSIGN_CASE_ERROR:
      return { ...state, re_unassignCase_success: false, re_unassignCase_error: true }

    default:
      return state
  }
}

const transferList = {
  re_transferList_success: false,
  re_transferList_error: false,
}

export const getLabTransferListResponseReducer = (state = transferList, action) => {
  switch (action.type) {
    case EMPTY_TRANSFER_LIST:
      return { ...state, re_transferList_success: false, re_transferList_error: true }
    case ADD_TRANSFER_LIST:
      return { ...state, re_transferList_success: true, re_transferList_error: false }
    default:
      return state
  }
}
